import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useHistory, useParams } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as LeftArrow } from '../../../../../assets/img/icon/ArrowLeft.svg';
import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import { appConfig } from '../../../../../config/app';
import { CustomEvents } from '../../../../../constants/analytics.constant';
import { iconTypes } from '../../../../../constants/notifications.constant';
import {
  COLLECTION_EXPIRED,
  COLLECTION_UP_TO_DATE,
  PaymentsTypes,
} from '../../../../../constants/policies.constant';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import { getFormattedDate } from '../../../../../helpers/getDate';
import useLogEventInAnalytics from '../../../../../hooks/useLogAnalyticsEvent';
import { GetPreference } from '../../../../../services/payments/payments.service';
import SendEmail from '../../../Documentation/Components/SendEmail.component';
import Navigation from '../../Navigation/Navigation.component';

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    backgroundColor: theme.palette.secondary.main,
  },
}));

const PaymentDetails = (props) => {
  const { policy, getPolicyById, loading } = useVehiclesContext();
  const { id }: any = useParams();
  const { user } = useAuthDataContext();
  const [preferenceId, setPreferenceId] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const { logEvent } = useLogEventInAnalytics();

  const setMercadoPagoPreferences = async () => {
    if (!preferenceId) {
      const body: any = {
        title: 'Próxima cuota',
        description: 'Monto correspondiente a su próxima cuota a pagar',
        quantity: 1,
        currency_id: 'ARS',
        unit_price: policy?.financial?.mercado_pago?.pending_amount,
        type: 'pending',
        policy_number: policy.number,
        payer: {
          email: user.email,
        },
      };

      const getPreferenceId = await GetPreference(body).then(
        (res) => res.data.preference_id
      );

      const script = document.createElement('script');
      script.src =
        'https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js';
      script.async = true;
      script.setAttribute('data-preference-id', getPreferenceId);
      script.setAttribute('data-button-label', 'Pagar con Mercado Pago');
      document.getElementById('mercadoForm')!.appendChild(script);
      setPreferenceId(true);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    if (Number(id) !== policy.id) {
      getPolicyById(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (
      policy.number &&
      !parseInt(policy?.financial?.mercado_pago?.maturities_amount) &&
      parseInt(policy?.financial?.mercado_pago?.pending_amount) > 0 &&
      policy?.financial?.mercado_pago?.can_pay
    ) {
      setMercadoPagoPreferences();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [policy]);

  useEffect(() => {
    logEvent(CustomEvents.PAYMENTS_VIEW, {
      app: appConfig?.NAME,
    });
  }, [logEvent]);

  //UseEfect que añade un listener luego de ejecutar el submit del form de mercado pago
  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (
        event.origin !== 'https://www.mercadopago.com.ar' ||
        !event.data.type
      ) {
        return;
      }

      let dataType = event.data.type; // "close", "submit", etc...

      if (dataType === 'submit') {
        //  const paymentData = event.data.value; // Es un arreglo con la respuesta del pago procesado.
        logEvent(CustomEvents.MP_PENDING_PAYMENT, {
          app: appConfig?.NAME,
        });
        getPolicyById(id);
        return;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const viewPendingPayments = () => {
    dataLayerPush('mis_pagos_pendientes', user?.id);
  };

  const pagarMercadoPago = () => {
    dataLayerPush('mis_pagos_pagarmp', user?.id);
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando póliza'}></Loader>
      </Box>
      <Box>{/* <Navigation /> */}</Box>
      {policy?.financial?.error || !policy?.financial ? (
        <Grid container justify="center" alignItems="center">
          <Grid item xs={11}>
            <Box position="absolute" top={'10%'}>
              <ButtonBase>
                <LeftArrow onClick={() => history.goBack()} />
              </ButtonBase>
            </Box>
          </Grid>
          <Grid item xs={11} sm={10} md={9} lg={8} xl={11}>
            <Box mt={5} ml={5}>
              <List>
                <ListItem divider> Póliza {policy?.number}</ListItem>

                <ListItem>
                  {/* <ListItemAvatar style={{ marginTop: '35px' }}>
                    <Avatar className={classes.avatar}>
                      <img
                        style={{ width: '100%' }}
                        src={iconTypes['mechanic_assistance']}
                        alt={'Notificacion'}
                      ></img>
                    </Avatar>
                  </ListItemAvatar> */}

                  <ListItemText
                    primary={
                      <Box mb={2}>
                        <Typography variant="h3">
                          ¡Te pedimos disculpas!
                        </Typography>
                      </Box>
                    }
                    secondary={
                      <>
                        <Typography variant="h4">
                          En este momento estamos actualizando la información de
                          tus pagos y próximos vencimientos. Pronto podrás
                          consultar toda tu información.
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              </List>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <>
          <SubHeader
            content={
              <Box>
                <Box my={3}>
                  <Typography variant="h6">Póliza {policy?.number}</Typography>
                </Box>
                <Box my={2}>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      {/* <Box my={2}>
                        <Typography color="primary">
                          {policy?.financial?.coverage
                            ? COLLECTION_UP_TO_DATE
                            : COLLECTION_EXPIRED}
                        </Typography>
                      </Box> */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box my={2}>
                        {policy?.financial?.maturities?.amount ? (
                          <Link
                            component={RouterLink}
                            to={`/account/payment/${id}/maturities`}
                            variant="subtitle2"
                            color="secondary"
                            onClick={viewPendingPayments}
                          >
                            Ver pagos pendientes
                          </Link>
                        ) : null}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <Box my={2}>
                        <Typography variant="caption">
                          {' '}
                          Próximo pago{' '}
                        </Typography>
                        {policy?.financial?.pending?.amount ? (
                          <Typography color="primary">
                            Vencimiento:{' '}
                            {getFormattedDate(
                              policy?.financial?.pending?.expiration_date
                            )}
                          </Typography>
                        ) : (
                          <Typography>
                            No tiene vencimientos próximos
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box my={2}>
                        <Typography variant="h6">
                          ${' '}
                          {policy?.financial?.pending?.amount
                            ? policy?.financial?.pending?.amount
                            : '0.00'}
                        </Typography>

                        <Typography display="block" variant="caption">
                          {policy?.payment_type_name}
                        </Typography>

                        <Typography display="block" variant="caption">
                          {policy?.payment_method}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            }
            actions={
              <Box>
                <Box mt={4} mb={2}>
                  {policy?.payment_type_name === PaymentsTypes['cupon'] && (
                    <SendEmail documentType={'payment_coupon'}></SendEmail>
                  )}
                </Box>
                <Box mt={4} mb={2}>
                  {policy?.financial?.mercado_pago?.can_pay &&
                    parseInt(policy?.financial?.mercado_pago?.pending_amount) >
                      0 && (
                      <form
                        action="javascript://"
                        method="POST"
                        id="mercadoForm"
                        onClick={() => pagarMercadoPago()}
                      />
                    )}
                </Box>
              </Box>
            }
            fullActions
          ></SubHeader>
          <Grid container justify="center">
            <Grid item xs={11}>
              <Grid container>
                <Grid item xs={12} sm={9} md={8} lg={7}>
                  <Box my={3}>
                    <Typography variant="subtitle2">
                      {' '}
                      Pagos anteriores{' '}
                    </Typography>
                    {policy?.financial?.collections.length ? (
                      <TableContainer>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell> Cuota </TableCell>
                              <TableCell align="left"> Estado </TableCell>
                              <TableCell align="right"> Monto </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {policy?.financial?.collections.map(
                              (collection: any) => (
                                <TableRow key={collection.id}>
                                  <TableCell component="th" scope="row">
                                    <Typography
                                      variant="subtitle2"
                                      color="primary"
                                    >
                                      {getFormattedDate(collection.date)}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left"> Pagada </TableCell>
                                  <TableCell align="right">
                                    <Typography
                                      variant="subtitle2"
                                      color="primary"
                                    >
                                      ${collection.amount}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : policy.sura_provider_id == 1 ? (
                      'En breve vas a poder ver tus pagos realizados acá.'
                    ) : (
                      'No registra pagos previos.'
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default PaymentDetails;
